
const Tokenizer = require("../tokenizer");
class PatternTokenizer extends Tokenizer {
    pattern;

    constructor(type, pattern) {
        super(type);
        this.pattern = pattern;
    }

    getToken(text, currentPos) {
        let char = text[currentPos];
        let consumedChars = 0;
        if (this.pattern.test(char)) {
            let prefix = char;
            let value = '';
            while (char && this.pattern.test(prefix)) {
                value = prefix;
                consumedChars++;
                prefix += text[currentPos + consumedChars];
            }
            return [consumedChars, {type: this.type, value: value}];
        }
        return [0, null]
    }
}

module.exports = PatternTokenizer;